import domain from "../../domain";
import cl from "./FoodComments.module.css";
import { IoCloseCircleSharp, IoClipboard, IoArchive } from "react-icons/io5";

import FoodFeedbackDisplay from "./FoodFeedbackDisplay";
import { useState } from "react";

// parent component -- FoodReviewComponent
export default function FoodComments({ data, setTagsData }) {
  // we use setTagsData to change Archived variable for Tags via state.
  //(locally and via DB as well later)

  // console.log(data);
  const [showFeedback, setShowFeedback] = useState(false);

  function showFeedbackHandler(e) {
    let feedbackId = e.target.parentNode.parentNode.nextSibling.id;
    let feedbackContainer = document.getElementById(feedbackId);
    if (!showFeedback) {
      feedbackContainer.style.display = "block";
    } else {
      feedbackContainer.style.display = "none";
    }
    setShowFeedback((p) => !p);
  }

  function closeFeedbackHandler(e) {
    console.log(e.target.parentNode.id);
    let feedbackId = e.target.parentNode.id;
    let feedbackContainer = document.getElementById(feedbackId);

    feedbackContainer.style.display = "none";

    setShowFeedback((p) => !p);
  }

  function archiveFoodIssue(mainId, id, isArchived) {
    // console.log(mainId);
    // console.log(id);
    // console.log("arvhiving");
    // we have to store

    setTagsData((prev) => {
      let newState = prev.map((item) => {
        if (item.mainId == mainId) {
          item.data.forEach((property) => {
            if (property.feedback_id == id) {
              property.isArchived = isArchived;
            }
          });
        }
        return item;
      });

      return newState;
    });

    // step 1 update locally(state variable) and step 2 upadte DB
    // and STep 3 update data in local storage

    // BElow we update DB as step 2
    fetch(`${domain}/api/archivefcomment`, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id, isArchived }),
    })
      .then((response) => {
        console.log("then case");
        console.log(response);

        // Now we make changes locally once change is made in DB.
        // step 3 changing local session storage.
        const storedData = JSON.parse(sessionStorage.getItem("mainData"));

        const newData = storedData.map((item) => {
          if (item._id == id) {
            item.archiveFoodComment = isArchived;
          }
          return item;
        });

        sessionStorage.setItem("mainData", JSON.stringify(newData));
        return response.json();
      })

      .catch((err) => {
        console.log("catch case");
        console.log(err);
      });
  }
  return (
    <>
      <h3>Comments</h3>

      <div className={cl.container}>
        {data.map((item, index) => {
          return (
            <div key={`${index} ffd`} className={cl.foodCommentContainer}>
              <div className={cl.foodNameContainer}>
                <p>{item.data[0].foodName}</p>
              </div>
              <div className={cl.foodIssueContainer}>
                {item.data.map((comment, index) => {
                  return (
                    <div key={`${index}forcomment`}>
                      <div
                        className={`${cl.foodIssue} ${
                          comment.isArchived && cl.foodIssueArchived
                        }`}
                      >
                        <p>{comment.foodIssue}</p>

                        <div className={`${cl.foodIssueIconsContainer} `}>
                          <div
                            className={`${cl.iconBox} ${cl.tooltip}`}
                            onClick={function (e) {
                              showFeedbackHandler(e);
                            }}
                          >
                            {" "}
                            <div className={`${cl.bookIcon} `}>
                              <IoClipboard />{" "}
                              <span className={cl.tooltiptext}>
                                Show Feedback Form
                              </span>
                            </div>
                          </div>{" "}
                          <div
                            className={`${cl.iconBox} ${cl.tooltip}`}
                            onClick={(e) =>
                              archiveFoodIssue(
                                item.mainId,
                                comment.feedback_id,
                                !comment.isArchived
                              )
                            }
                          >
                            <div className={cl.iconArchive}>
                              <IoArchive />
                              <span className={cl.tooltiptext}>
                                {`${
                                  comment.isArchived
                                    ? `Unarchive Comment`
                                    : `Archive Comment`
                                }`}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id={comment.feedback_id}
                        className={`  ${cl.feedbackContainer}`}
                      >
                        <div
                          className={cl.iconBox}
                          onClick={(e) => closeFeedbackHandler(e)}
                        >
                          <div className={`${cl.iconUp} ${cl.topClosingIcon}`}>
                            <IoCloseCircleSharp />
                          </div>
                        </div>
                        <FoodFeedbackDisplay data={comment.feedback_id} />
                        <div
                          className={cl.iconBox}
                          onClick={(e) => closeFeedbackHandler(e)}
                        >
                          <div className={cl.iconUp}>
                            <IoCloseCircleSharp />
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
